export default __webpack_public_path__ + "static/media/jaqueraimundo.f7703ae5.jpg";